// GETTERS

// ACTIONS
export const FETCH_PUBLISHER_IDS_WITH_STATS = 'FETCH_PUBLISHER_IDS_WITH_STATS';
export const FETCH_CAMPAIGN_PUBLISHER_STATS = 'FETCH_CAMPAIGN_PUBLISHER_STATS';
export const FETCH_DAILY_STATS = 'FETCH_DAILY_STATS';
export const FETCH_CAMPAIGN_CONTENT_DAILY_STATS = 'FETCH_CAMPAIGN_CONTENT_DAILY_STATS';
export const FETCH_GEO_LOCATION_IDS_WITH_STATS = 'FETCH_GEO_LOCATION_IDS_WITH_STATS';
export const FETCH_GEO_STATS = 'FETCH_GEO_STATS';
export const DOWNLOAD_CONTENT_REPORT_CSV = 'DOWNLOAD_CONTENT_REPORT_CSV';
export const DOWNLOAD_GEO_REPORT_CSV = 'DOWNLOAD_GEO_REPORT_CSV';
export const FETCH_OVERALL_CREATIVE_CAMPAIGN_STATS = 'FETCH_OVERALL_CREATIVE_CAMPAIGN_STATS';
export const FETCH_REPORT_STATEMENTS_FOR_TYPE = 'FETCH_REPORT_STATEMENTS_FOR_TYPE';
export const UPDATE_REPORT_STATEMENTS_FOR_TYPE = 'UPDATE_REPORT_STATEMENTS_FOR_TYPE';
export const FETCH_CAMPAIGN_REPORT_CONFIGURATION = 'FETCH_CAMPAIGN_REPORT_CONFIGURATION';
export const UPDATE_CAMPAIGN_REPORT_CONFIGURATION = 'UPDATE_CAMPAIGN_REPORT_CONFIGURATION';
export const UPLOAD_CAMPAIGN_SCREENSHOT = 'UPLOAD_CAMPAIGN_SCREENSHOT';
export const FETCH_CAMPAIGN_SCREENSHOT_NAMES = 'FETCH_CAMPAIGN_SCREENSHOT_NAMES';
export const FETCH_CAMPAIGN_SCREENSHOT_IMAGE = 'FETCH_CAMPAIGN_SCREENSHOT_IMAGE';
export const DOWNLOAD_SCREENSHOTS_ARCHIVE = 'DOWNLOAD_SCREENSHOTS_ARCHIVE';
export const DELETE_CAMPAIGN_SCREENSHOT = 'DELETE_CAMPAIGN_SCREENSHOT';
export const SHOULD_SUPPRESS_GEO_TAB = 'SHOULD_SUPPRESS_GEO_TAB';

// MUTATIONS
export const SET_REPORT_STATEMENTS_FOR_TYPE = 'SET_REPORT_STATEMENTS_FOR_TYPE';
export const SET_CAMPAIGN_REPORT_CONFIGURATION = 'SET_CAMPAIGN_REPORT_CONFIGURATION';
export const SET_CAMPAIGN_SCREENSHOTS_NAMES = 'SET_CAMPAIGN_SCREENSHOTS_NAMES';
export const ADD_CAMPAIGN_SCREENSHOTS_NAME = 'ADD_CAMPAIGN_SCREENSHOTS_NAME';
export const REMOVE_CAMPAIGN_SCREENSHOTS_NAME = 'REMOVE_CAMPAIGN_SCREENSHOTS_NAME';

// ACTIONS + MUTATIONS
export const PUBLISH_CAMPAIGN_REPORT_STATEMENTS = 'PUBLISH_CAMPAIGN_REPORT_STATEMENTS';
export const UPDATE_SUMMARY_ENABLED_STATEMENTS = 'UPDATE_SUMMARY_ENABLED_STATEMENTS';
